export default __webpack_public_path__ + "static/media/4705_bp.7c90e414.svg";